import { render } from "./InfoModal.vue?vue&type=template&id=afbc6394"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"
script.render = render

export default script